/* ==========================================================
   WANSTER Shoe Size Assistant v2.0
   FINAL PART 1
========================================================== */

(() => {
  "use strict";

  const sizeData = {
    "17": { age: "0–6M", foot: "10.5 cm (4.13\")" },
    "18": { age: "6–12M", foot: "11.0 cm (4.33\")" },
    "19": { age: "1–2Y", foot: "11.5 cm (4.53\")" },
    "20": { age: "1–2Y", foot: "12.0 cm (4.72\")" },
    "21": { age: "1–2Y", foot: "12.5 cm (4.92\")" },
    "22": { age: "2–3Y", foot: "13.0 cm (5.11\")" },
    "23": { age: "2–3Y", foot: "14.0 cm (5.51\")" },
    "24": { age: "3–4Y", foot: "14.5 cm (5.70\")" },
    "25": { age: "3–4Y", foot: "15.5 cm (6.10\")" },
    "26": { age: "4–5Y", foot: "16.0 cm (6.29\")" },
    "27": { age: "5–6Y", foot: "16.5 cm (6.49\")" },
    "28": { age: "5–6Y", foot: "17.5 cm (6.88\")" },
    "29": { age: "6–7Y", foot: "18.0 cm (7.08\")" },
    "30": { age: "6–7Y", foot: "18.5 cm (7.28\")" },
    "31": { age: "7–8Y", foot: "19.5 cm (7.67\")" },
    "32": { age: "7–8Y", foot: "20.0 cm (7.87\")" },
    "33": { age: "8–9Y", foot: "21.0 cm (8.26\")" },
    "34": { age: "9–10Y", foot: "21.5 cm (8.46\")" },
    "35": { age: "10–11Y", foot: "22.0 cm (8.66\")" },
    "36": { age: "11–12Y", foot: "22.5 cm (8.85\")" },
    "37": { age: "12–13Y", foot: "23.5 cm (9.25\")" }
  };

  const app = {
    foot: null,
    age: null,
    popup: null,
    table: null,
    openBtn: null,
    closeBtn: null,
    overlay: null
  };

  function initElements() {
    app.foot = document.getElementById("wanster-foot-length");
    app.age = document.getElementById("wanster-age");

    app.popup = document.getElementById("wanster-size-popup");
    app.table = document.getElementById("wanster-size-table-body");

    app.openBtn = document.getElementById("wanster-size-chart-btn");
    app.closeBtn = document.getElementById("wanster-popup-close");
    app.overlay = document.querySelector(".wanster-popup-overlay");
  }

  function getSelectedSize() {

  const checked = document.querySelector(
    'fieldset.product-form__input input[type="radio"]:checked'
  );

  if (checked) {
    return checked.value.trim();
  }

  const select = document.querySelector(
    'select[name="options[EU Size]"]'
  );

  if (select) {
    return select.value.trim();
  }

  return null;

}

  window.WANSTER = {
    sizeData,
    app,
    getSelectedSize
  };

  console.log("WANSTER v2 Loaded");

})();
/* ==========================================================
   FINAL PART 2
   Variant Detection + Auto Update
========================================================== */

(() => {

  const { app, sizeData, getSelectedSize } = window.WANSTER;

  function updateInfo() {

    if (!app.foot || !app.age) return;

    const size = getSelectedSize();

    if (!size || !sizeData[size]) {

      app.foot.textContent = "Select a size";
      app.age.textContent = "Select a size";

      return;
    }

    app.foot.textContent = sizeData[size].foot;
    app.age.textContent = sizeData[size].age;

  }

  function watchVariants() {

    document.addEventListener("change", function(e){

      if (
    e.target.matches('fieldset.product-form__input input[type="radio"]') ||
    e.target.matches('select[name^="options["]')
) {

        setTimeout(updateInfo,100);

      }

    });

  }

function firstLoad(){

    updateInfo();

    setTimeout(updateInfo,100);

    setTimeout(updateInfo,300);

    setTimeout(updateInfo,700);

}

  document.addEventListener("DOMContentLoaded",function(){

    init();

  });

  function init(){

    app.foot=document.getElementById("wanster-foot-length");
    app.age=document.getElementById("wanster-age");

    firstLoad();

    watchVariants();

  }

})();

/* ==========================================================
   FINAL PART 3
   Size Chart Popup
========================================================== */

(() => {

  const { app, sizeData, getSelectedSize } = window.WANSTER;

  function buildTable() {

    if (!app.table) return;

    app.table.innerHTML = "";

    const selected = getSelectedSize();

    Object.keys(sizeData).forEach((size) => {

      const row = document.createElement("tr");

      if (size === selected) {
        row.classList.add("active");
      }

      row.innerHTML = `
        <td>EU ${size}</td>
        <td>${sizeData[size].age}</td>
        <td>${sizeData[size].foot}</td>
      `;

      app.table.appendChild(row);

    });

  }

  function openPopup(e) {

    e.preventDefault();

    buildTable();

    app.popup.hidden = false;

    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

  }

  function closePopup() {

    app.popup.hidden = true;

    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";

  }

  document.addEventListener("DOMContentLoaded", () => {

    app.popup = document.getElementById("wanster-size-popup");
    app.table = document.getElementById("wanster-size-table-body");

    app.openBtn = document.getElementById("wanster-size-chart-btn");
    app.closeBtn = document.getElementById("wanster-popup-close");
    app.overlay = document.querySelector(".wanster-popup-overlay");

    if (app.openBtn)
      app.openBtn.addEventListener("click", openPopup);

    if (app.closeBtn)
      app.closeBtn.addEventListener("click", closePopup);

    if (app.overlay)
      app.overlay.addEventListener("click", closePopup);

    document.addEventListener("keydown", function (e) {

      if (e.key === "Escape" && app.popup && !app.popup.hidden) {
        closePopup();
      }

    });

  });

})();